import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderGroupUpdate } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchSliderGroupUpdate = createAsyncThunk(
    'sliderGroupUpdate/fetchSliderGroupUpdate',
    async ({ id, filesToKeep, file, title, description, content, }) => {
        const response = await SliderGroupUpdate(id, file, title, description, content, filesToKeep)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const sliderGroupUpdateSlice = createSlice({
    name: 'sliderGroupUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderGroupUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderGroupUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderGroupUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderGroupUpdateSlice.reducer;
